module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073f2_banner_800x600.a251aaa9.png";